import T from '../../../../common/components/T';
import FormCheckbox from '../../../form/components/form-checkbox/FormCheckbox/FormCheckbox';
import Counter from '../../../grid/cells/Counter/Counter';
import css from './Table.module.scss';
import classNames from 'classnames';

const Tr = (props) => {
    const { key, product, handlers } = props;

    const getHandlers = (key) => {
        const funcs = handlers['count'][key];
        return Object.keys(funcs).reduce((accum, handlerName) => {
            accum[handlerName] = () => funcs[handlerName](product);
            return accum;
        }, {});
    };
    return (
        <div key={key} className={classNames(css.tr, { [css.trActive]: product.activeRow })}>
            <div className={css.trLeft}>
                <FormCheckbox
                    setFormData={() => handlers?.activeRow?.change?.onChange(product)}
                    value={product.activeRow ? '1' : '0'}
                    compStyle={{
                        label: { className: css.checkbox },
                        checkBox: { className: css.checkBox },
                        wrapper: { width: 'initial' }
                    }}
                />
                <div className={css.trLeftCont}>
                    <p className={css.name}>{product.name}</p>
                    <p className={css.article}>
                        <span className={css.articleLabel}>
                            <T textName='article' defaultStr='Артикул' />:
                        </span>
                        <span className={css.articleValue}>{product.article || '-'}</span>
                    </p>
                    <Counter val={product.count} getHandlers={getHandlers} />
                </div>
            </div>
            <div className={css.trRight}>{product?.price?.price_for_client || '-'}</div>
        </div>
    );
};

export default function Table(props) {
    const { data, params } = props;
    const handlers = params?.handlers;
    return (
        <div className={css.table}>
            <div className={css.tableHead}>
                <p className={css.th}>
                    <T textName='name' defaultStr='Название' />
                </p>
                <p className={css.th}>
                    <T textName='scores-in-pv' defaultStr='Баллов, PV' />
                </p>
            </div>
            <div className={css.tableBody}>
                {data?.data?.length ? (
                    data.data.map((product) => <Tr handlers={handlers} key={product.id} product={product} />)
                ) : (
                    <p className={css.noData}>
                        <T textName='gridNoData' defaultStr='Нет данных' page='all' />
                    </p>
                )}
            </div>
        </div>
    );
}
